/**
 * 라이브러리 발표. 텍스트형 덱은 열 수 있으면(내 자료) 덱을 그대로 띄워 글자를 선명하게 보여 주고,
 * 열 수 없으면(나눔터·권한 없음·실패) 저장된 장 그림으로 발표한다.
 */

import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { loadFreeDesign } from '../../api/freeDesignApi';
import { Spinner } from '../common/AsyncState';
import PresentationMode from '../chat/PresentationMode';
import FreeDesignPresent from '../chat/freeDesign/FreeDesignPresent';
import './LibraryPresentation.css';

export default function LibraryPresentation({ presentation, onClose, allowDeck = true }) {
  const deckId = allowDeck ? presentation?.deckId : null;
  const [deck, setDeck] = useState(null);
  const [loading, setLoading] = useState(Boolean(deckId));

  useEffect(() => {
    if (!deckId) return undefined;
    let alive = true;
    setLoading(true);
    loadFreeDesign(deckId)
      .then((loaded) => { if (alive && loaded?.slides?.length) setDeck(loaded); })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [deckId]);

  if (loading) {
    return createPortal(
      <div className="wqlib-present-loading" data-testid="wqlib-present-loading" role="status">
        <Spinner label="발표 화면을 여는 중" size={32} tone="inverse" />
      </div>,
      document.body,
    );
  }
  if (deck) {
    return <FreeDesignPresent head={deck.head} onClose={onClose} slides={deck.slides} />;
  }
  if (!presentation?.slides?.length) return null;
  return <PresentationMode onClose={onClose} slides={presentation.slides} />;
}
